import React from 'react';

const ReferralContext = React.createContext(null);

export const ReferralProvider = ReferralContext.Provider;

export default ReferralContext;